/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDocumentDto } from '../../models/admin-document-dto';

export interface AdminDocumentControllerDelete$Params {
  id: string;
}

export function adminDocumentControllerDelete(http: HttpClient, rootUrl: string, params: AdminDocumentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminDocumentDto>;
    })
  );
}

adminDocumentControllerDelete.PATH = '/api/adminDocument/{id}';
